
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/golfkentat/[slug]",
      function () {
        return require("private-next-pages/golfkentat/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/golfkentat/[slug]"])
      });
    }
  